import { CheckboxOptionInput, useFormItemEnabled } from '@framework/form';
import clx from 'classnames';
import React, { useMemo } from 'react';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { IWidgetComponentOptionProps } from '../../../../IWidgetType';
import { ParagraphSizeText } from '../../../common/style/ParagraphSizeText';
import { OptionLabel } from '../../common/option-list/style/OptionLabel';
import { IMultiSelectWidget } from '../IMultiSelectWidget';
import { multiSelectOptionsObjectName } from '../getMultiSelectOptionsObjectName';

export interface IMultiSelectOptionPorps
  extends IWidgetComponentOptionProps<IMultiSelectWidget> {}

/**
 * Componente per la renderizzazione di un unica option del MultiSelect.
 * Nello specifico, si tratta di una checkbox.
 */
export function MultiSelectOption(props: IMultiSelectOptionPorps) {
  const { option, groupName, hideLabel } = props;

  const optionsObjectName = multiSelectOptionsObjectName(groupName);

  // Prendo dal context l'editabilità del widget "scelta multipla"
  // o comunque del parent. Se disabilitato, è disabilitato anche il figlio.
  const { enabled, layoutEnabled } = useFormItemEnabled();

  const parentDisabled = useMemo(
    () => enabled === false || layoutEnabled === false,
    [enabled, layoutEnabled]
  );

  if (!option) return;

  return (
    <CheckboxOptionInput
      readOnly={props.readonly}
      className={clx({ 'hide-label': hideLabel })}
      name={groupName}
      optionName={`${optionsObjectName}.${option.value as string}`}
      optionValue={option.value}
      disabled={parentDisabled}
    >
      <OptionLabel hideLabel={hideLabel}>
        <ParagraphSizeText>
          <RichTextAdvancedRender hasCustomFont inline text={option.label} />
        </ParagraphSizeText>
      </OptionLabel>
    </CheckboxOptionInput>
  );
}
